import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs/Rx';
import { otpVerify } from 'src/app/models/User';
import { APIConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})

export class OtpService {
   constructor(private httpClient : HttpClient) { }
  readonly url = APIConstants.BASE_URL

  private otpAutoFill = new Subject<string>();
  public readonly isOtpAutoFilled = this.otpAutoFill.asObservable();

  
  sendOtp(number: string): Observable<any>{
    let headers = new HttpHeaders({
      'Content-type': 'application/json'
    })
  
    return this.httpClient.post<any>(this.url + "/otp/send?phoneNumber=" + number+"&signature="+environment.host,{headers});
}

  checkOtp(otp: otpVerify): Observable<any>{
  let headers = new HttpHeaders({
    'Content-type': 'application/json'
  })
  return this.httpClient.post<any>(this.url + "/otp/verify",otp,{headers});
}
  public fillOtp(otp: any){
    this.otpAutoFill.next(otp);
  }

}

export class ApiResponse {
  timestamp: String;
 status: Number;
 message : String;
 body : OTPModel ;
 }

 

 export class OTPModel { 
  otpId: String;
  otp:String;
  phoneNumber: String;
 }